import React from 'react';

export const EmployeeTipBreakdown = ({ data, role }) => {
  if (!data) {
    return (
      <div className="text-center py-4 text-gray-500">
        No tip breakdown data available
      </div>
    );
  }

  // Normalize role to an array - handle string, comma-separated string, or array
  let roles = [];
  if (Array.isArray(role)) {
    roles = role;
  } else if (typeof role === 'string') {
    // Split by comma and trim whitespace
    roles = role.split(',').map(r => r.trim()).filter(r => r);
  } else {
    roles = [role];
  }

  // Convert each role to its corresponding key format and map to data
  const roleBreakdowns = roles.map((r) => {
    const key = r?.toLowerCase().replace(/\s+/g, '_');
    return {
      role: r,
      key: key,
      data: data[key],
    };
  }).filter(item => item.data && (item.data.total > 0 || item.data.tax > 0)); // Only show roles with actual tip data

  if (roleBreakdowns.length === 0) {
    return (
      <div className="text-center py-4 text-gray-500">
        No tip data available for {Array.isArray(role) ? role.join(', ') : role}
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Role</th>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Amount</th>
            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Tax</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200">
          {roleBreakdowns.map(({ role, data }) => (
            <tr key={role} className="hover:bg-gray-50">
              <td className="px-4 py-3 text-sm font-medium capitalize">{role}</td>
              <td className="px-4 py-3 text-sm">
                ${data.total?.toFixed(2) || '0.00'}
              </td>
              <td className="px-4 py-3 text-sm">
                ${data.tax?.toFixed(2) || '0.00'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};